import {AppAction} from '../../appActions';
import {LegacyPanelActionsEnum} from './legacyPanelActions';
import {LegacyPanelState} from './legacyPanelState';

/*
 * Reducers.
 */

export function legacyPanelReducer(state: LegacyPanelState, action: AppAction): LegacyPanelState {
  switch (action.type) {
    case LegacyPanelActionsEnum.NAVIGATED: {
      const {path} = action.payload;
      if (state.path === path) {
        return state;
      }

      return {...state, path};
    }

    default:
      return state;
  }
}
